import { lazy } from 'react';

const Companies = lazy(() => import('./Companies'));

export default Companies;
